import React from "react";
import Form from "../components/form";
import "../global.css";

export default function Index() {
  return (
    <>
      <h1>Send a Message</h1>
      <Form />
    </>
  );
}
